import React from 'react';

import ErrorIcon from '~/core/iconComponents/icons/ErrorIcon';
import cn from '~/utils/cn';

export interface SkeletonTableProps {
  rowsCount: number;
  columnsCount: number;
  isError?: boolean;
  cellClassName?: string;
}

const SkeletonTableCell: React.FC<{ cellClassName?: string }> = ({ cellClassName }) => (
  <div className={cn('flex h-20 w-full animate-pulse px-12 text-slate-400', cellClassName)}>
    <div className="h-full w-full rounded-lg bg-current" />
  </div>
);

const SkeletonTable: React.FC<SkeletonTableProps> = ({ rowsCount, columnsCount, isError = false, cellClassName }) => {
  if (isError) {
    return <ErrorIcon size={30} />;
  }

  return (
    <div className={`h-full w-full p-16`} data-testid="skeleton-table">
      <div className="flex w-full justify-around p-16">
        <SkeletonTableCell cellClassName={cellClassName} />
      </div>
      {Array.from({ length: rowsCount }, (_, index) => (
        <div key={index} className="flex w-full justify-around p-16">
          {Array.from({ length: columnsCount }, (_, columnIndex) => (
            <SkeletonTableCell key={columnIndex} cellClassName={cellClassName} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default SkeletonTable;
